<template>
  <div class="pay-day-loan-interest-rate">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t('list.createPayDayLoanInterestRate') }}
        </h3>
      </div>
      <div class="box-body">
        <pay-day-loan-interest-rate-form />
      </div>
    </div>
  </div>
</template>

<script>
import PayDayLoanInterestRateForm from './Form'
export default {
  name: 'NewPayDayLoanInterestRate',
  components: { PayDayLoanInterestRateForm },
  metaInfo () {
    return {
      title: this.$t('string.addNewInterestRate'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  }
}
</script>

<style scoped>

</style>
